"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingForm = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
const react_uid_1 = require("react-uid");
const react_router_dom_1 = require("react-router-dom");
const AccessTime_1 = __importDefault(require("@mui/icons-material/AccessTime"));
const Today_1 = __importDefault(require("@mui/icons-material/Today"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const useLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useLogin"));
const MultiSelect_1 = __importDefault(require("../FormFields/MultiSelect"));
const HandoverScreen_1 = __importDefault(require("../Other/HandoverScreen"));
const AreaSelect_1 = __importDefault(require("../FormFields/AreaSelect"));
const helpers_1 = require("../../../common/helpers/helpers");
const BookingLimitsErrorOrNotice_1 = __importDefault(require("./BookingLimitsErrorOrNotice"));
const TextField_1 = __importDefault(require("../FormFields/TextField"));
const SingleSelect_1 = __importDefault(require("../FormFields/SingleSelect"));
const TimeSuggestions_1 = __importDefault(require("./TimeSuggestions"));
const AcceptTerms_1 = __importDefault(require("../FormFields/AcceptTerms"));
const NotificationPermissions_1 = __importDefault(require("../Notifications/NotificationPermissions"));
const MultiUnitSelect_1 = __importDefault(require("../FormFields/MultiUnitSelect"));
const DateAndTime = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(/* webpackChunkName: "DateAndTime" */ '../FormFields/DateAndTime')))));
const MainWrapper = styled_components_1.default.div `
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  &.page-form {
    max-width: 600px;
  }

  &.modal-form {
    form {
      max-width: none;
    }
  }
`;
const BookingTitle = styled_components_1.default.div `
  font-size: 1.2rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.87);
`;
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  padding: 10px 0;
  margin: 14px;
  > div {
    position: relative;
    display: block;
    left: 0;
    top: 0;
    margin: 0 auto;
  }
`;
const BookingFormWrapper = styled_components_1.default.div `
  min-height: calc(100% - 60px);

  color: rgba(0, 0, 0, 0.6);
  font-size: 1rem;

  form {
    height: 100%;
    margin: 0 auto;
  }

  .form {
    &-subtitle {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.4px;
      margin-bottom: 20px;
    }
  }

  .mt-25 {
    margin-top: 25px;
  }
`;
const BookingPrivacyHint = styled_components_1.default.div `
  white-space: pre-line;
`;
const FormValidationError = styled_components_1.default.div `
  background: #d53324;
  color: #fff;
  padding: 16px;
  text-align: center;

  @media (min-width: 840px) {
    padding: 16px 24px;
  }
`;
const ErrorWrapper = styled_components_1.default.div `
  padding: 20px;
  font-size: 1rem;
  text-align: center;
`;
const BookingConfirmationTextWrapper = styled_components_1.default.div `
  width: 100%;
  padding: 16px;
`;
const ParticipateBtnWrapper = styled_components_1.default.div `
  position: sticky;
  bottom: 0;
  width: calc(100% + 32px);
  margin-left: -16px;
  padding: 16px;
  background-color: #fff;
  z-index: 2;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;
const StyledLoadingButton = (0, styled_components_1.default)(LoadingButton_1.default) `
  width: 100%;
`;
const FormFieldsWrapper = styled_components_1.default.div `
  overflow: auto;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const StaticTime = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;

  div {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ededed;
    margin-right: 5px;
    padding: 5px;
    border-radius: 5px;
    svg {
      margin-right: 5px;
    }
  }
`;
const PermisisonWrapper = styled_components_1.default.div `
  position: absolute;
  bottom: 16px;
  left: 20px;
  right: 20px;
  margin: 0 auto;
`;
const TIME_UNTILE_LOCKED_REQUEST_IS_RETRIED = 5000;
const hasProperty = (obj, prop) => {
    return prop in obj;
};
const BookingForm = (props) => {
    const { activeItem, currentLocale, userData, walkinRegistration, timezone, disableStartTime, isPageForm } = props;
    const history = (0, react_router_dom_1.useHistory)();
    const { slug } = (0, react_router_dom_1.useParams)();
    const { token } = userData;
    const [bookingError, setBookingError] = (0, react_1.useState)('');
    const [isKidsClubEnabled, setIsKidsClubEnabled] = (0, react_1.useState)(false);
    const [disableButton, setDisableButton] = (0, react_1.useState)(false);
    const { isLoginRequired, loginUrl } = (0, useLogin_1.default)(userData);
    const [fields, setFields] = (0, react_1.useState)([]);
    const [availability, setAvailability] = (0, react_1.useState)({});
    const [bookingStatus, setBookingStatus] = (0, react_1.useState)('');
    const [bookingConfirmationText, setBookingConfirmationText] = (0, react_1.useState)('');
    const [timeSuggestions, setTimeSuggestions] = (0, react_1.useState)([]);
    const [timeSuggestionsTitle, setTimeSuggestionsTitle] = (0, react_1.useState)('');
    const [timeSuggestionsError, setTimeSuggestionsError] = (0, react_1.useState)('');
    const [timeSuggestionsHint, setTimeSuggestionsHint] = (0, react_1.useState)('');
    const [fetchingTimeSuggestions, setFetchingTimeSuggestions] = (0, react_1.useState)(true);
    const [bookingAvailabilityStatus, setBookingAvailabilityStatus] = (0, react_1.useState)(true);
    const [bookingAvailabilityError, setBookingAvailabilityError] = (0, react_1.useState)('');
    const [bookingNotice, setBookingNotice] = (0, react_1.useState)('');
    const [bookButtonText, setBookButtonText] = (0, react_1.useState)('');
    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
    const formatDateAndTime = (dateField) => {
        if (!dateField.value) {
            const dateAndTime = dateField.placeholder.split(' ');
            const time = dateAndTime.length > 1
                ? dateAndTime[1]
                : `${helpers_1.Helpers.getHourFromDate(new Date().toString(), timezone).substr(0, 2)}:00`;
            return `${formatDate(new Date())} ${time}`;
        }
        if (dateField.value.split('T').length > 1) {
            return `${formatDate(new Date(dateField.value))} ${helpers_1.Helpers.getTimeFromISODate(dateField.value)}`;
        }
        return dateField.value;
    };
    const formatAvailabilityFields = (unformatedFields, content) => unformatedFields.map((field) => {
        if (disableStartTime && field.id === 'starts_at' && (field.type === 'datetime' || field.type === 'date')) {
            const date = getActivityDate(content.start, true);
            const time = helpers_1.Helpers.getHourFromDate(content.start, timezone);
            return Object.assign(field, {
                value: `${date} ${time}`,
            });
        }
        if (field.type === 'datetime' || field.type === 'date') {
            return Object.assign(field, {
                value: formatDateAndTime(field),
            });
        }
        if (field.type === 'single_select_inline' || field.type === 'single_select') {
            if (!field.value) {
                return Object.assign(field, {
                    value: field.options[0].label,
                });
            }
        }
        return field;
    });
    const prefillField = (initialFields, prefillId, prefillValue) => {
        if (prefillId && prefillValue) {
            return initialFields.map((field) => {
                if (field.id === prefillId) {
                    return Object.assign(field, {
                        value: prefillValue,
                    });
                }
                return field;
            });
        }
        return initialFields;
    };
    const generateFetchSuggestionsParams = (initialFields = [], availabilityId, isInitialSetup = false) => {
        const formFields = initialFields.length > 0 ? initialFields : fields;
        const pax = formFields.find(field => field.id === 'pax');
        const startTime = formFields.find(field => field.id === 'starts_at');
        const multiArea = formFields.find(field => field.type === 'area_multi_select');
        if (pax && startTime) {
            const table = formFields.find(field => field.type === 'table_select');
            const area = formFields.find(field => field.type === 'area_select');
            let selectedArea;
            let selectedTable;
            let multipleAreaIds = [];
            if (table) {
                selectedTable = table.value
                    ? table.options.find(option => option.label === table.value)
                    : table.options.find(option => option.selected);
            }
            if (area) {
                selectedArea = area.value
                    ? area.options.find(option => option.label === area.value)
                    : area.options.find(option => option.selected);
            }
            if (multiArea && multiArea.value && !isInitialSetup) {
                multipleAreaIds = multiArea.value.flatMap(option => Array(option.quantity).fill(option.id));
            }
            return [
                currentLocale,
                userData.token,
                availabilityId,
                pax.value,
                startTime.value && startTime.value.split('T').length > 1
                    ? startTime.value
                    : helpers_1.Helpers.getISOString(formatDateAndTime(startTime)),
                selectedTable ? selectedTable.id : '',
                selectedArea ? selectedArea.id : '',
                multiArea ? multipleAreaIds : undefined,
            ].filter(param => param !== undefined);
        }
        return [];
    };
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!activeItem.content.availability) {
            setBookingError(i18n_js_1.default.t('page_not_found'));
            return;
        }
        const deeplinkHref = isPageForm ? window.location.href : `${activeItem.content.deeplink}/book`;
        const deeplinkResolver = (yield apiService_1.default.resolveDeeplink(currentLocale, deeplinkHref));
        if (deeplinkResolver.status === 'error') {
            setBookingError(deeplinkResolver.message);
            return;
        }
        const prefillFieldId = deeplinkResolver.fieldId;
        const prefillFieldValue = deeplinkResolver.fieldValue;
        const { availabilityId } = deeplinkResolver;
        const type = activeItem.type === 'convention_activity' ? 'activity' : activeItem.type;
        const bookingAvailability = (yield apiService_1.default
            .checkBookingAvailability(currentLocale, token, availabilityId, walkinRegistration)
            .catch(error => {
            if (error.status === 'error') {
                setBookingAvailabilityStatus(false);
                setBookingAvailabilityError(error.message);
            }
        }));
        const availabilityData = bookingAvailability.booking.bookable[type].availability;
        const params = generateFetchSuggestionsParams(availabilityData.fields, availabilityId, true);
        if (params.length > 0) {
            const isMultiUnit = params[7] !== undefined;
            let suggestionsData;
            if (isMultiUnit) {
                suggestionsData = yield apiService_1.default.getTimeSuggestionsForMultiUnit(...params);
            }
            else {
                suggestionsData = yield apiService_1.default.getTimeSuggestions(params[0], params[1], params[2], params[3], params[4], params[5], params[6], walkinRegistration);
            }
            if (suggestionsData.status === 'success') {
                setTimeSuggestions(suggestionsData.suggestions);
                setTimeSuggestionsTitle(suggestionsData.texts.label);
                if (suggestionsData.texts.bookButton) {
                    setBookButtonText(suggestionsData.texts.bookButton);
                }
                availabilityData.fields.map((field) => {
                    if (field.id === 'starts_at') {
                        const firstSelectedSuggestion = suggestionsData.suggestions.find(suggestion => suggestion.selected);
                        if (firstSelectedSuggestion) {
                            return Object.assign(field, {
                                value: firstSelectedSuggestion.value,
                            });
                        }
                    }
                    return field;
                });
            }
            else {
                setTimeSuggestionsError(suggestionsData.message);
            }
        }
        if (bookingAvailability.notice) {
            setBookingNotice(bookingAvailability.notice.info);
        }
        const formatedAvailabilityFields = formatAvailabilityFields(prefillField(availabilityData.fields, prefillFieldId, prefillFieldValue), activeItem.content);
        setAvailability(availabilityData);
        setFields(formatedAvailabilityFields);
        setBookingStatus(bookingAvailability.booking.state);
        setIsKidsClubEnabled(availabilityData.kidsClubEnabled);
        setFetchingTimeSuggestions(false);
    });
    (0, react_1.useEffect)(() => {
        initialSetup();
    }, []);
    const fetchSuggestions = helpers_1.Helpers.debounce((newFields = fields) => {
        const params = generateFetchSuggestionsParams(newFields, availability.id);
        if (params.length > 0) {
            setFetchingTimeSuggestions(true);
            const isMultiUnit = params[7] !== undefined;
            let apiPromise;
            if (isMultiUnit) {
                apiPromise = apiService_1.default.getTimeSuggestionsForMultiUnit(...params);
            }
            else {
                apiPromise = apiService_1.default.getTimeSuggestions(params[0], params[1], params[2], params[3], params[4], params[5], params[6], walkinRegistration);
            }
            apiPromise.then((suggestionsData) => {
                if (suggestionsData.status === 'success') {
                    setTimeSuggestions(suggestionsData.suggestions.map(suggestion => Object.assign(suggestion, { selected: false })));
                    setTimeSuggestionsTitle(suggestionsData.texts.label);
                    setTimeSuggestionsError('');
                    setTimeSuggestionsHint('');
                    if (suggestionsData.texts.bookButton) {
                        setBookButtonText(suggestionsData.texts.bookButton);
                    }
                }
                else {
                    setTimeSuggestionsError(suggestionsData.message);
                    if (isMultiUnit && suggestionsData.actions && suggestionsData.actions.length > 0) {
                        setTimeSuggestionsHint(suggestionsData.actions[0].label);
                    }
                    else {
                        setTimeSuggestionsHint('');
                    }
                }
                setFetchingTimeSuggestions(false);
            });
        }
    }, 500);
    const handleValueChange = (activeField) => event => {
        const newValue = event.target.value;
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: newValue, errors: [] });
            }
            return field;
        }));
    };
    const handlePaxChange = (activeField) => event => {
        const newValue = event.target.value;
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: newValue, errors: [] });
            }
            return field;
        }));
        if (!fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const handleDateAndTimeChange = (activeField, selectedDate) => {
        const date = new Date(selectedDate);
        const isoString = date.toISOString();
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, {
                    value: isoString,
                    errors: [],
                });
            }
            return field;
        }));
        if (activeField.id === 'starts_at' && !fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const handleSuggestionClick = (selectedSuggestion) => {
        const fullDate = `${formatDate(new Date(selectedSuggestion.value))} ${helpers_1.Helpers.getTimeFromISODate(selectedSuggestion.value)}`;
        setFields(fields.map((field) => {
            if (field.id === 'starts_at') {
                return Object.assign(field, {
                    value: fullDate,
                    errors: [],
                });
            }
            return field;
        }));
    };
    const createBooking = () => {
        const preparedFields = helpers_1.Helpers.prepareBookingFields(fields, 'availability');
        sessionStorage.setItem('paymentReturnVenueSlug', slug);
        sessionStorage.setItem('currentLocale', currentLocale);
        apiService_1.default
            .createBooking(currentLocale, token, availability.id, preparedFields, walkinRegistration)
            .then(response => {
            var _a, _b;
            if (response.status === 'locked_retry') {
                handleLockedRow();
                return;
            }
            const { bookingData } = response;
            if (bookingData.payment && bookingData.payment.serviceUrl) {
                window.location.href = bookingData.payment.serviceUrl;
                return;
            }
            if (activeItem.type === 'activity' || activeItem.type === 'convention_activity') {
                const activityId = '-' + activeItem.content.deeplink.split('-').pop(); // get the last part of the deeplink as an ID
                const evt = new CustomEvent('activityWasBooked', { detail: { activityId } });
                window.dispatchEvent(evt);
            }
            const type = activeItem.type === 'convention_activity' ? 'activity' : activeItem.type;
            const availabilityData = (_b = (_a = bookingData.bookable) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.availability;
            if (availabilityData) {
                setAvailability(availabilityData);
                setFields(availabilityData.fields);
                if (availabilityData.errors && availabilityData.errors.length > 0) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            }
            setBookingStatus(bookingData.state);
            setDisableButton(false);
            setBookingConfirmationText(bookingData.texts ? bookingData.texts.text : '');
        })
            .catch(error => {
            var _a, _b, _c;
            setDisableButton(false);
            if (error.booking) {
                const type = activeItem.type === 'convention_activity' ? 'activity' : activeItem.type;
                const newFields = (_c = (_b = (_a = error.booking.bookable) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.availability) === null || _c === void 0 ? void 0 : _c.fields;
                if (newFields) {
                    setFields(newFields);
                }
                const errorElement = document.querySelector('.field-error');
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    };
    const handleLockedRow = () => {
        setTimeout(() => {
            createBooking();
        }, TIME_UNTILE_LOCKED_REQUEST_IS_RETRIED);
    };
    const handleSubmit = event => {
        event.preventDefault();
        setDisableButton(true);
        createBooking();
    };
    const handleAcceptTermsChange = (activeField, termsAccepted) => {
        setFields(fields.map(field => {
            if (field.id === activeField.id) {
                return Object.assign(field, { value: termsAccepted ? 'true' : 'false', errors: [] });
            }
            return field;
        }));
    };
    const handleMultiSelectChange = (activeField) => {
        setFields(fields.map(field => {
            if (field.id === activeField.id) {
                const multiSelectValue = activeField.options.filter(option => option.selected).map(option => option.id);
                return Object.assign(field, { value: multiSelectValue, errors: [] });
            }
            return field;
        }));
    };
    const handleMultiUnitSelectChange = (activeField) => {
        setFields(prevFields => {
            const newFields = prevFields.map(field => {
                if (field.id === activeField.id) {
                    const multiSelectValue = activeField.options
                        .filter(option => option.selected)
                        .map(option => ({ id: option.id, quantity: option.quantity || 1 }));
                    return Object.assign({}, field, { value: multiSelectValue, errors: [] });
                }
                return field;
            });
            if (activeField.type === 'area_multi_select' && !fetchingTimeSuggestions) {
                fetchSuggestions(newFields);
            }
            return newFields;
        });
    };
    const handleSingleSelectChange = (activeField, selectedOption) => {
        setFields(fields.map((field) => {
            if (field.id === activeField.id) {
                return Object.assign(field, {
                    value: selectedOption,
                    errors: [],
                });
            }
            return field;
        }));
        if ((activeField.type === 'table_select' || activeField.type === 'area_select') && !fetchingTimeSuggestions) {
            fetchSuggestions();
        }
    };
    const isMultiUnitBooking = fields.some(field => field.type === 'area_multi_select');
    const renderFields = () => fields
        .filter(field => {
        if (isMultiUnitBooking && field.type === 'hidden' && field.id === 'pax') {
            return false;
        }
        return field.semanticType !== 'ends_at';
    })
        .map(field => {
        const { type } = field;
        const switchCase = field.id === 'pax' ? 'pax' : type;
        switch (switchCase) {
            case 'datetime':
            case 'date':
                if (disableStartTime && field.id === 'starts_at') {
                    return (react_1.default.createElement(material_1.Box, { className: "mt-25", key: (0, react_uid_1.uid)(field) },
                        react_1.default.createElement("p", null,
                            " ",
                            i18n_js_1.default.t('date_and_time'),
                            " "),
                        react_1.default.createElement(StaticTime, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(AccessTime_1.default, null),
                                getActivityDisplayTime(activeItem.content, currentLocale, timezone)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(Today_1.default, null),
                                getActivityDisplayDate(activeItem.content.start, currentLocale)))));
                }
                return (react_1.default.createElement(react_1.default.Fragment, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(material_1.Box, { className: "mt-25" },
                        react_1.default.createElement(DateAndTime, { fieldData: field, onChange: handleDateAndTimeChange, withPastDates: true, currentLocale: currentLocale })),
                    field.id === 'starts_at' && (react_1.default.createElement(material_1.Box, null, fetchingTimeSuggestions ? (react_1.default.createElement(LoaderWrapper, null,
                        react_1.default.createElement(Loader_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(TimeSuggestions_1.default, { suggestions: timeSuggestions, title: timeSuggestionsTitle, error: timeSuggestionsError, hint: timeSuggestionsHint, handleSuggestionClick: handleSuggestionClick })))))));
            case 'table_select':
            case 'area_select':
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(AreaSelect_1.default, { fieldData: field, onChange: handleSingleSelectChange })));
            case 'single_select':
            case 'single_select_inline':
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(SingleSelect_1.default, { fieldData: field, onChange: handleSingleSelectChange })));
            case 'section_heading':
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement("h3", null, field.label)));
            case 'multi_select':
            case 'multi_select_inline': {
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field), className: "mt-25" },
                    react_1.default.createElement(MultiSelect_1.default, { fieldData: field, onChange: handleMultiSelectChange })));
            }
            case 'accept_terms':
                return react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) }, react_1.default.createElement(AcceptTerms_1.default, { fieldData: field, onChange: handleAcceptTermsChange }));
            case 'area_multi_select':
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(MultiUnitSelect_1.default, { fieldData: field, onChange: handleMultiUnitSelectChange })));
            case 'pax':
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(TextField_1.default, { fieldData: field, onChange: handlePaxChange })));
            default:
                return (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(field) },
                    react_1.default.createElement(TextField_1.default, { fieldData: field, onChange: handleValueChange })));
        }
    });
    if (isLoginRequired && !walkinRegistration) {
        window.location.href = loginUrl;
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (bookingError) {
        return react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" }, bookingError);
    }
    if (isKidsClubEnabled) {
        return react_1.default.createElement(HandoverScreen_1.default, null);
    }
    if (bookingConfirmationText && bookingStatus) {
        return (react_1.default.createElement(BookingConfirmationTextWrapper, null,
            react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: bookingConfirmationText,
                    } })),
            react_1.default.createElement(PermisisonWrapper, null,
                react_1.default.createElement(NotificationPermissions_1.default, null))));
    }
    const modalClass = isPageForm ? 'page-form' : 'modal-form';
    if (Object.keys(availability).length > 0) {
        return (react_1.default.createElement(MainWrapper, { className: modalClass },
            hasProperty(availability, 'errors') &&
                availability.errors.map(error => {
                    if (error === 'is invalid') {
                        return false;
                    }
                    return (react_1.default.createElement(material_1.Box, null,
                        react_1.default.createElement(FormValidationError, { key: error }, error)));
                }),
            react_1.default.createElement(BookingFormWrapper, { "data-testid": "booking-form-wrapper", className: walkinRegistration ? 'walkin-registration' : '' },
                react_1.default.createElement("form", { onSubmit: handleSubmit, id: "bookingActivityForm" },
                    isPageForm && react_1.default.createElement(BookingTitle, null, activeItem.content.title),
                    react_1.default.createElement(FormFieldsWrapper, null,
                        react_1.default.createElement(material_1.Box, null,
                            bookingNotice !== '' && (react_1.default.createElement(material_1.Box, null,
                                react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: bookingNotice }))),
                            !isMultiUnitBooking && react_1.default.createElement(material_1.Typography, { className: "form-subtitle" },
                                " ",
                                i18n_js_1.default.t('participants'),
                                " "),
                            renderFields(),
                            react_1.default.createElement(material_1.Box, { className: "mt-25" },
                                react_1.default.createElement(BookingPrivacyHint, null, i18n_js_1.default.t('privacy_booking_hint'))),
                            react_1.default.createElement(material_1.Box, null,
                                react_1.default.createElement("a", { href: "https://www.hotel-mssngr.com/en/app/default/privacy", target: "_blank", rel: "noopener noreferrer" }, i18n_js_1.default.t('privacy_statement_link')))))),
                react_1.default.createElement(material_1.Dialog, { open: Boolean(bookingStatus && !bookingConfirmationText), TransitionComponent: Transition, keepMounted: true, onClose: () => history.goBack(), "aria-describedby": "alert-dialog-slide-description" },
                    react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('confirmed_booking_alert_title')),
                    react_1.default.createElement(material_1.DialogContent, null,
                        react_1.default.createElement(material_1.DialogContentText, { id: "alert-dialog-slide-description" }, i18n_js_1.default.t('confirmed_booking_alert_message'))),
                    react_1.default.createElement(material_1.DialogActions, null,
                        react_1.default.createElement(material_1.Button, { onClick: () => history.goBack() }, "Ok")))),
            react_1.default.createElement(ParticipateBtnWrapper, null,
                react_1.default.createElement(StyledLoadingButton, { loading: disableButton, disabled: disableButton, type: "submit", fullWidth: true, variant: "contained", form: "bookingActivityForm" }, bookButtonText ||
                    (hasProperty(availability, 'textsForDisplay') && availability.textsForDisplay.bookButton)))));
    }
    if (bookingAvailabilityStatus === false) {
        return react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: bookingAvailabilityError, isError: true });
    }
    return react_1.default.createElement(Loader_1.default, null);
};
exports.BookingForm = BookingForm;
function getActivityDate(start, formatYMD = false) {
    const activityDate = new Date(start);
    const date = activityDate.getDate();
    const month = activityDate.getMonth() + 1;
    const year = activityDate.getFullYear();
    if (formatYMD) {
        return `${year}/${month}/${date}`;
    }
    return `${date}/${month}/${year}`;
}
function getActivityDisplayDate(dateStart, currentLocale) {
    const { date } = helpers_1.Helpers.getDateFromStringDependingLocale(dateStart, currentLocale);
    return `${date}`;
}
function getActivityDisplayTime(content, currentLocale, timezone) {
    if (!content.showStartTime && !content.showEndTime) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, currentLocale, timezone).time;
    const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.end, currentLocale, timezone).time;
    if (content.showStartTime && content.showEndTime) {
        return `${startTime} - ${endTime}`;
    }
    return startTime;
}
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    timezone: store.getValue('timezone'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.BookingForm);
